<template>
  <v-dialog
    v-bind="$attrs"
    v-on="$listeners"
    width="auto"
    max-width="80%"
    @close="close"
  >
    <v-img
      :src="img_path"
      :class="$style.dialogImage"
      @click="close"
    />
  </v-dialog>
</template>

<script lang="ts">
import {
  Component, Vue, Prop, Emit,
} from 'vue-property-decorator';

@Component
export default class ImagePreviewDialog extends Vue {
  dialog = false;
  dialogImage = '';

 @Prop({ type: String, default: '' })
 img_path!: string;

 @Emit('close')
 close() {
   //
 }
}
</script>

<style module lang="scss">
.dialogImage {
  object-fit: contain;
}
</style>
